<template>
  <div id="discount-voucher">
    <div class="ipub-h1 mar-b-12 line-h-40 relative">
      Discount Voucher

      <div class="ipub-p1 right-option">
        <ipub-button type="primary"
                     v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.DISCOUNT_VOUCHER.EXPORT')"
                     @click="exp">
          Export
        </ipub-button>
      </div>
    </div>
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="6">
            <ipub-input placeholder="Search by discount code, Manuscript No., voucher value"
                        @keypress.enter.native="getList()"
                        v-model.trim="params.keyword" />
          </ipub-col>
          <ipub-col :span="6">
            <site-search-group v-model.trim="params.emailOrName"
                               placeholder="Search by email, name"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="4"
                      class="flex">
              <span class="line-h-40 nowrap fw-bd"
                    style="width:160px">From Journal(s)</span>
              <ipub-select v-model="params.fromJournalId"
                           placeholder="Select Journal"
                           @change="changeJournal"
                           :options="journalList" />
            </ipub-col>
            <ipub-col :span="4"
                      class="flex">
              <span class="line-h-40 nowrap fw-bd"
                    style="width:160px">Used Journal(s)</span>
              <ipub-select v-model="params.usedJournalId"
                           placeholder="Select Journal"
                           @change="changeJournal"
                           :options="journalList" />
            </ipub-col>
            <ipub-col :span="4"
                      class="flex">
              <span class="line-h-40 nowrap fw-bd">Status</span>
              <ipub-select v-model="params.status"
                           @change="getList()"
                           class="mar-l-12"
                           :clear="true"
                           placeholder="Select Status">
                <template v-for="(value, key) in DISCOUNT_STATUS">
                  <ipub-select-option :key="key+'123'"
                                      :value="key">
                    {{ value }}
                  </ipub-select-option>
                </template>
              </ipub-select>
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="6"
                      class="flex"
                      style="align-items:center">
              <span class="line-h-40 nowrap fw-bd">Created Date</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width:calc(100% - 100px)"
                                      :placeholder="['From','To']"
                                      @change="grantDateChange"
                                      v-model="grantDate" />
            </ipub-col>
            <ipub-col :span="6"
                      class="flex"
                      style="align-items:center">
              <span class="line-h-40 nowrap fw-bd">Expired Date</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width:calc(100% - 100px)"
                                      :placeholder="['From','To']"
                                      @change="expiredDateChange"
                                      v-model="expiredDate" />
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>

    <ipub-table :columns="columns"
                @order="onOrderChanage"
                :pagination="pagination"
                :dataSource="dataSource">
      <template v-slot:code="{text}">
        <ipub-tooltip placement="bottomLeft"
                      class="ipub-p2 omis">
          <div slot="title">
            {{text}}
          </div>
          <div class="omis">{{text}}</div>
        </ipub-tooltip>
        <ipub-icon @click="copyCode(text)"
                   class="ipub-c-p"
                   type="iconduplicate"></ipub-icon>
      </template>
      <template v-slot:discount="{text}">
        $ {{text}}
      </template>
      <template v-slot:fromR="{text}">
        <div v-if="text">
          <div class="link-color ipub-c-p"
               @click="openPerson(text)">{{text.firstName}} {{text.lastName}}</div>
          <div>{{text.email}}</div>
        </div>
        <div v-else>- -</div>

      </template>
      <template v-slot:fromM="{text}">
        <div v-if="text">{{text.manuscriptCode}}</div>
        <div v-else>- -</div>
      </template>
      <template v-slot:status="{text}">
        <div v-if="text">

          <ipub-label type="danger"
                      style="width:72px"
                      size="small"
                      v-if="text==='EXPIRED'"
                      cover>{{DISCOUNT_STATUS[text]}}</ipub-label>
          <ipub-label type="success"
                      style="width:72px"
                      size="small"
                      v-else-if="text==='UNUSED'"
                      cover>{{DISCOUNT_STATUS[text]}}</ipub-label>
          <ipub-label type="default"
                      style="width:72px"
                      size="small"
                      v-else
                      cover>{{DISCOUNT_STATUS[text]}}</ipub-label>
        </div>
        <div v-else>- -</div>
      </template>

    </ipub-table>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
